export default __webpack_public_path__ + "static/media/logo.2041e7b3.png";